import { Flex, FloraButton } from '@grupoboticario/flora-react';
import { SquareArrowRightUpIcon } from '@grupoboticario/flora-react-icons';
import { Link } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components';
import { parseToStarlink } from 'helpers';

import Styles from './RulesDoubts.styles';
import { useLoyaltyIncentiveCampaign } from '../../hooks';

export const RulesDoubts = () => {
  const { data: incentiveCampaign } = useLoyaltyIncentiveCampaign();

  return (
    <Styles.Wrapper>
      <Flex direction='column' align='self-start' gap='$6'>
        <Flex direction='column' gap='$3'>
          <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold'>
            Possui alguma dúvida?
          </ResponsiveFloraTypography>

          <ResponsiveFloraTypography color='$nonInteractiveAuxiliar'>
            Tenha acesso às principais dúvidas sobre o incentivo.
          </ResponsiveFloraTypography>
        </Flex>

        <FloraButton
          as={Link}
          to={parseToStarlink(incentiveCampaign?.faq?.url)}
          target='_blank'
          icon={<SquareArrowRightUpIcon size={16} />}
          has='iconLeft'
          hierarchy='secondary'
          autotagging-flora='on'
          data-flora='button'
          data-flora-text='duvidas-frequentes'
        >
          <ResponsiveFloraTypography fontSize='bodySmallStandard' fontWeight='bold'>
            Dúvidas frequentes
          </ResponsiveFloraTypography>
        </FloraButton>
      </Flex>

      <Flex direction='column' align='self-start' gap='$6'>
        <Flex direction='column' gap='$3'>
          <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold'>
            Confira o regulamento
          </ResponsiveFloraTypography>

          <ResponsiveFloraTypography color='$nonInteractiveAuxiliar'>
            Para mais informações, acesse o regulamento completo.
          </ResponsiveFloraTypography>
        </Flex>

        <FloraButton
          as={Link}
          to={parseToStarlink(incentiveCampaign?.regulations?.url)}
          target='_blank'
          icon={<SquareArrowRightUpIcon size={16} />}
          has='iconLeft'
          hierarchy='secondary'
          autotagging-flora='on'
          data-flora='button'
          data-flora-text='regulamento-do-programa'
        >
          <ResponsiveFloraTypography fontSize='bodySmallStandard' fontWeight='bold'>
            Regulamento do programa
          </ResponsiveFloraTypography>
        </FloraButton>
      </Flex>
    </Styles.Wrapper>
  );
};
